import { Button, Modal, Alert } from "@mantine/core";

function ModalError({
  opened,
  close,
  errorMessage
}) {
  return (
    <Modal
      opened={opened}
      onClose={close}
      size="lg"
      title="Informacion (Cerrando en 3 segundos...)"
      centered
      withCloseButton={false}
    >
      <Alert icon={<i className="fas fa-exclamation-triangle"></i>} color="red" mb={30} >
        {errorMessage.map((err, index) => (
          <div key={`${index}_${err}`}>
            <span style={{ fontSize: "1.6rem" }}>{err}</span> <br />
          </div>
        ))}
      </Alert>
    </Modal>
  )
}

export default ModalError